<template>
  <div class="partners-page">
    <div class="wrapper">
      <div class="d-flex flex-column justify-content-center partners-container subtit">
        <p class="bcLiguria partners-text">{{$t('partners.text')}}</p>
      </div>
      <transition-group
        name="fade-in-right-group"
        mode="out-in"
        tag="div"
        :style="{ '--total': partners.length }"
        class="partners-container d-flex flex-row flex-wrap mt-4"
      >
        <PartnerBox v-for="(partner, iPartner) in partners"
          :key="'partner-' + iPartner"
          :style="{'--i': iPartner}"
          :partner="partner"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import PartnerBox from '@/components/PartnerBox'
import partners from '../assets/js/partners.json'
import { fadeInOutSection } from '@/assets/js/animations'

export default {
  name: 'Partners',
  components: {
    PartnerBox
  },
  data () {
    return {
      partners
    }
  },
  mounted () {
    fadeInOutSection()
  }
}
</script>

<style scoped lang="scss">
.partners-page {
  background-color: #1A1A1A;
}

.partners-container {
  min-height: 50vh;
  background-color: #1A1A1A;
  padding: 0 var(--main-space);

  &:deep .person, &:deep figure, &:deep .person-info-container{
    background-color: #1A1A1A!important;
  }

  &:deep figure{
    display: flex;
    align-items: center;
  }

  &:deep .person{
    display: flex;
    align-items: center;
  }

  &:deep .person-container{
    width: 50%;
  }
}

.wrapper {
  padding-inline: 0 !important;
  .subtit {
    width: 100%;
    padding-top: 160px;
    min-height: 100vh;
    height: auto;
    p {
      color: #fff;
      max-width: calc(100% - 80px);
      font-size: 66px;
      line-height: 1.21;
    }
  }
}

@include media-breakpoint-down(lg) {
  .wrapper .subtit p {
    font-size: 30px;
    line-height: 1.3;
  }
}

@include media-breakpoint-down(sm) {
  .wrapper{
    .subtit {
      // height: auto!important;
      min-height: calc(100vh - 160px)!important;
      width: 100%;
      p {
        font-size: 26px;
        width: 100%;
        max-width: inherit!important;
        padding: 0;
        min-height: inherit;
      }
    }
  }
  .partners-container {
    &:deep .person-container{
      width: 100%;
      flex-direction: column!important;
    }
    &:deep .person{
      margin-top: -60px;
      .person-info-container{
        padding: 0!important;
      }
      figure{
        padding: 0!important;
      }
    }
  }
}
</style>
